import axiosApiInstance from "../../../helpers/interceptor";

const getSingleStatsCoreIdPath =
  "/backoffice/marcacionesV2/getSingleStatsCoreId";

const getAllConfigsPath = "/backoffice/marcacionesV2/getAllConfigs";

const getStatsByServiceAndConfigurationPath =
  "/backoffice/marcacionesV2/getStatsByServiceAndConfiguration";

export const marcacionesGetSingleStatsCoreIdAPI = async (
  request: SingleStatsRequest
): Promise<{ error: string; stats: SingleStatsResponse | null }> => {
  try {
    const response = await axiosApiInstance.post(
      getSingleStatsCoreIdPath,
      request
    );
    return { error: "", stats: response.data };
  } catch (error) {
    return { error: error.message, stats: null };
  }
};

export const marcacionesGetAllConfigsAPI = async (): Promise<{
  error: string;
  configs: ViewConfig[] | null;
}> => {
  try {
    const response = await axiosApiInstance.get(getAllConfigsPath);
    return { error: "", configs: response.data };
  } catch (error) {
    return { error: error.message, configs: null };
  }
};

export const marcacionesGetStatsByServiceAndConfigurationAPI = async (
  request: StatsByServiceAndConfigurationRequest
): Promise<{ error: string; stats: MultiStatsResponse | null }> => {
  try {
    const response = await axiosApiInstance.post<MultiStatsResponse>(
      getStatsByServiceAndConfigurationPath,
      request
    );

    return { error: "", stats: response.data };
  } catch (error) {
    return { error: error.message, stats: null };
  }
};

// DTOS
export interface ViewConfig {
  _id: string;
  clientId: string;
  viewName: string;
}

export interface SingleStatsRequest {
  entityId: string;
  viewConfigId: string;
}

export interface StatsByServiceAndConfigurationRequest {
  viewConfigId: string;
  startDatetime: string;
  endDatetime: string;
}

export interface SingleStat {
  eventName: string;
  date: string;
  durationMs: number;
}

export interface SingleStatsResponse {
  stats: SingleStat[];
}

export interface MultiStats {
  eventName: string;
  eventName2?: string;
  averageDurationMs: number;
  count: number;
  maxDurationMs: number;
  minDurationMs: number;
  stdevDurationMs: number;
}

export interface MultiStatsResponse {
  stats: MultiStats[];
}
